/** @format */
import angular from 'angular';
import { BasicGroupingPanelComponent } from '../grouping-panel/basic-grouping-panel.component';
import { decimalNumberFilterModule } from '../number/decimalNumber.filter';
import customStudyDraftSummaryTpl from './customStudyDraftSummary.tpl.html';

export const customStudyDraftSummaryModule = 'sis-components.customStudyDraftSummary';

angular
    .module(customStudyDraftSummaryModule, [decimalNumberFilterModule, BasicGroupingPanelComponent.downgrade.moduleName])
    .component('customStudyDraftSummary', {
        template: customStudyDraftSummaryTpl,
        bindings: {
            customStudyDraft: '<',
        },
    });
